"use client"

import styled from "styled-components"
import { useApp } from "../contexts/AppContext"

const ProgressBar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: ${({ $progress }) => $progress}%;
  height: 3px;
  background: ${({ theme }) => theme.colors.gradientPrimary};
  z-index: ${({ theme }) => theme.zIndex.fixed};
  transition: width 0.1s ease;
  box-shadow: ${({ theme }) => theme.shadows.glow};

  &::after {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    width: 10px;
    height: 100%;
    background: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 10px ${({ theme }) => theme.colors.primary};
  }
`

const ScrollProgress = () => {
  const { scrollProgress } = useApp()

  return <ProgressBar $progress={scrollProgress} />
}

export default ScrollProgress
